// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "icon-2EjgN";
var _4 = "content-2SVPy";
var _5 = "scrollBody-3-oQS";
var _6 = "paper-3LACd";
export { _1 as "__esModule", _2 as "mobile", _3 as "icon", _4 as "content", _5 as "scrollBody", _6 as "paper" }
export default { "__esModule": _1, "mobile": _2, "icon": _3, "content": _4, "scrollBody": _5, "paper": _6 }
